import React from 'react'
import { useParams } from 'react-router-dom'

const InviteGuest = () => {
    const token = localStorage.getItem('h-access_token') // replace this with your method of getting the token
    const { legacyGroupId } = useParams()

    const getMainDomain = (hostname) => {
        const parts = hostname.split('.')
        return parts.slice(-2).join('.')
    }
    const mainDomain = getMainDomain(window.location.hostname)
    const subdomain = window.location.hostname.startsWith('ithaca-stage') ? 'key-stage' : 'admin';
    const adminDomain = `${subdomain}.${mainDomain}`
    const url = `https://${adminDomain}/my2/invite-guest/${legacyGroupId}/?token=${token}`

    return (
        <div>
            <iframe src={url}
                    style={{ width: '100%', height: 'calc(100vh - 80px)' }}
                    title="InviteGuest"></iframe>
        </div>
    )
}

export default InviteGuest
